const isBlank = (value, message = true) => {
  const isString = 'string' === typeof value;
  const valueWithoutSpaces = isString ? value.trim() : value;

  if (!valueWithoutSpaces) {
    return message;
  }

  return undefined;
};

export default isBlank;
